import React from "react";
import DocumentTitle from "react-document-title";

import "./Apartments.scss";

import Link from "../components/Link";
import PhotoPreview from "../components/PhotoPreview";
import Lightbox from "../components/Lightbox";
import PageHero from "../components/PageHero";
import PageHeroContentSection from "../components/PageHeroContentSection";
import UpNextContentSection from "../components/UpNextContentSection";
import VirtualTourModal from "../components/VirtualTourModal";
import { getPageTitle } from "../utility/utility";

import floorplan1Br from "../download/Floorplan_1BR.pdf";
import floorplan1BrTerrace from "../download/Floorplan_1BR_Terrace.pdf";
import floorplan2Br1Bd from "../download/Floorplan_2BR_1B.pdf";
import floorplan2Br2Bd from "../download/Floorplan_2BR.pdf";
import floorplanStudio1 from "../download/Floorplan_Studio_1.pdf";
import floorplanStudio2 from "../download/Floorplan_Studio_2.pdf";

import preview1 from "../images/apartments/preview/photo-1.jpg";
import preview2 from "../images/apartments/preview/photo-2.jpg";
import preview3 from "../images/apartments/preview/photo-3.jpg";

import full1 from "../images/apartments/full/photo-1.jpg";
import full2 from "../images/apartments/full/photo-2.jpg";
import full3 from "../images/apartments/full/photo-3.jpg";
import full4 from "../images/apartments/full/photo-4.jpg";
import full5 from "../images/apartments/full/photo-5.jpg";
import full6 from "../images/apartments/full/photo-6.jpg";

import viewBrochure from "../download/300_Ashland_Brochure_WEB.pdf";

const PHOTOS = [
  {
    preview: preview1,
    full: full1,
    caption:
      "Expansive floor-to-ceiling windows with sweeping views of Brooklyn fill every corner of each apartment with natural light.",
  },
  {
    preview: preview2,
    full: full2,
    caption:
      "Bedrooms feature customized closets and pre-installed solar shades.",
  },
  {
    preview: preview3,
    full: full3,
    caption:
      "Every kitchen includes Bosch and Energy Star appliances, dishwasher and in-sink disposal.",
  },
  {
    full: full4,
    caption:
      "Every kitchen includes Bosch and Energy Star appliances, dishwasher and in-sink disposal.",
  },
  {
    full: full5,
    caption:
      "Every unit includes in-unit Bosch washer/dryer, keyless electronic apartment entry and pre-installed solar shades.",
  },
  {
    full: full6,
    caption: "Bathrooms feature Grohe fixtures.",
  },
];

const FLOORPLANS = [
  {
    img: floorplanStudio1,
    name: "Studio 1",
  },
  {
    img: floorplanStudio2,
    name: "Studio 2",
  },
  {
    img: floorplan1Br,
    name: "1 Br",
  },
  {
    img: floorplan1BrTerrace,
    name: "1 Br with Terrace",
  },
  {
    img: floorplan2Br1Bd,
    name: "2 Br 1 Ba",
  },
  {
    img: floorplan2Br2Bd,
    name: "2 Br 2 Ba",
  },
];

export default class ApartmentsPage extends React.Component {
  state = {
    initialLightboxSlide: -1,
    modalOpen: false,
  };

  static pageTitle(listings, routeParams) {
    // eslint-disable-line no-unused-vars
    return "Fort Greene Brooklyn Apartments w/ Balconies | 300 Ashland Pl";
  }

  renderPhotoPreview(index) {
    return (
      <PhotoPreview
        photo={PHOTOS[index]}
        className={`photo-preview-${index + 1} collage__item`}
        onClick={() => this.setState({ initialLightboxSlide: index })}
        onKeyPress={() => this.setState({ initialLightboxSlide: index })}
      />
    );
  }

  openModal = () => {
    // ga('garp.send', "event", "3D", "Click", "Matterport", "0");
    this.setState({ modalOpen: true });
  };

  closeModal = () => {
    // ga('garp.send', "event", "3D", "Click", "Matterport", "0");
    this.setState({ modalOpen: false });
  };

  render() {
    return (
      <DocumentTitle title={getPageTitle(this.constructor, this.props)}>
        <div className="content" id="main" role="main">
          <PageHero heading="The Apartments">
            <PageHeroContentSection>
              <h2>
                Carefully considered to use the distinct building design to
                maximum effect, every unit was built with high-quality materials
                and features a full suite of amenities.
              </h2>
              <p>
                Every room in every unit features expansive windows with
                panoramic city views that fill every corner with natural light,
                and include pre-installed solar shades. White oak hardwood
                floors, Corian window sills, and Caesarstone and stainless steel
                countertops complement Bosch kitchen appliances and Grohe
                bathroom fixtures. Energy Star rated appliances and LED lighting
                help make your home more eco-friendly. Every unit includes
                built-in washer/dryer units, in-sink garbage disposals and
                keyless electronic apartment entry.
              </p>

              <div className="row sample-floorplans">
                <span className="icon-pdf"></span>
                <div>
                  <h4>Download Sample Floorplans</h4>
                  <div className="links">
                    {FLOORPLANS.map(({ img, name }) => [
                      <a href={img} target="_blank" key={name}>
                        {name}
                      </a>,
                      " ",
                    ]).reduce((a, b) => a.concat(b), [])}
                  </div>
                </div>
              </div>
              <div className="row tours-button">
                <button className="button" onClick={this.openModal}>
                  3D VIRTUAL TOURS
                </button>
              </div>
            </PageHeroContentSection>
          </PageHero>

          <div className="collage">
            <div className="row">
              <div className="feature features-1">
                <h6>Features</h6>
                <ul>
                  <li>Full-length balcony units</li>
                  <li>Expansive windows</li>
                  <li>Oak floors</li>
                  <li>Pre-installed solar shades</li>
                  <li>Customized closets</li>
                </ul>
              </div>
              {this.renderPhotoPreview(0)}
            </div>

            <div className="row">
              <div className="column">
                {this.renderPhotoPreview(1)}
                <div className="feature features-2">
                  <h6>Features</h6>
                  <ul>
                    <li>Dishwasher</li>
                    <li>In-unit washer/dryer</li>
                    <li>In-sink garbage disposal</li>
                    <li>Caesarstone &amp; stainless steel countertops</li>
                    <li>Energy Star and Bosch appliances</li>
                  </ul>
                </div>
              </div>
              {this.renderPhotoPreview(2)}
            </div>
          </div>

          <UpNextContentSection isButtonGroupCta={true}>
            <h5>See our available apartments</h5>
            <div className="up-next-content-section__button-group">
              <Link
                to="/availability"
                className="button button--primary button--elongated up-next-content-section__button"
              >
                View Availabilities
              </Link>
              <a
                href={viewBrochure}
                target="_blank"
                className="button button--primary button--elongated up-next-content-section__button"
              >
                View the Brochure
              </a>
            </div>
          </UpNextContentSection>

          <Lightbox
            slides={PHOTOS.map((it) => ({
              img: { src: it.full, caption: it.caption },
            }))}
            startSlide={this.state.initialLightboxSlide}
            onClose={() => this.setState({ initialLightboxSlide: -1 })}
          />

          <VirtualTourModal
            isOpened={this.state.modalOpen}
            onClose={this.closeModal}
          />
        </div>
      </DocumentTitle>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/Apartments.js